import React from 'react';
import
    {
        Avatar,
        Badge,
    } from '@mui/material';
import
    {
        withStyles
    } from '@mui/styles';

const ProfileBadge = withStyles(() => ({}))(Badge);

// const theme = createTheme();
// const useStyles = makeStyles({
//     cameraAlt: {
//         position: 'absolute',
//         right: '18%',
//         bottom: '18%',
//         transform: 'scale(1) translate(50%, 50%)',
//         transformOrigin: '100% 100%',
//         zIndex: '2',
//         height: theme.spacing(3.25),
//         width: theme.spacing(3.25),
//     },
// });

const ProfileImage = (props) =>
{
    // const classes = useStyles();

    return (
        <ProfileBadge>
            {/* <IconButton
                onClick={props.handleClick}
                className={classes.cameraAlt}>
                <CameraAltIcon
                    fontSize="small"
                    style={{
                        color: '#9c9292',
                    }}
                />
            </IconButton> */}
            <Avatar
                alt="User"
                src={props.src}
                onClick={props.handleClick}
                sx={{
                    width: props.width ? props.width : 100,
                    height: props.width ? props.width : 100,
                    cursor: 'pointer',
                    borderRadius:'0px !important',
                }}
            />
        </ProfileBadge>
    );
};

export default ProfileImage;
